
import { useRoute, RouteMeta } from 'vue-router'
import { defineComponent, watch,computed,onMounted,ref } from 'vue'
import {catalogPaths} from '@/composables/useCatalogReferral'
import customerRequest from '@/api/customer'
import router from '@/router'
import { generateTitle } from '@/utils/lang'
import store from '@/store'
export default defineComponent({
  setup() {
    const route = useRoute()
    const getTitle = (meta: RouteMeta): string => {
      if (meta) {
        return generateTitle(meta.title)
      } else {
        return ''
      }
    }
    const getKeepAlive=(path)=>{
      const paths=['/main/bokes','/main/cloths','/main/decorations','/main/fabrics','/main/accessories']
      const n=paths.includes(path)
      return n
    }
    
    const path=computed(()=>{
      return router.currentRoute.value.path
    })
    const referralKey='ld-list-share-referral'
    const browserKey='ld-list-share-browser-id'
    const newBrowserId=():string=>{
      const bytes=window.crypto.getRandomValues(new Uint8Array(16))
      bytes[6]=(bytes[6]&15)|64;bytes[8]=(bytes[8]&63)|128
      const hex=Array.from(bytes,byte=>byte.toString(16).padStart(2,'0')).join('')
      return `${hex.slice(0,8)}-${hex.slice(8,12)}-${hex.slice(12,16)}-${hex.slice(16,20)}-${hex.slice(20)}`
    }
    watch([()=>route.fullPath,()=>store.getters.userInfo?.id,()=>store.getters.orgId],async()=>{
      const orgId=Number(store.getters.orgId),referrerId=Number(route.query.referrerId)
      if(catalogPaths.has(route.path) && Number.isSafeInteger(referrerId) && referrerId>0
          && Number(route.query.orgId)===orgId){
        localStorage.setItem(referralKey,JSON.stringify({orgId,referrerId,time:Date.now()}))
      }
      try{
        const pending=JSON.parse(localStorage.getItem(referralKey)||'null')
        if(!pending)return
        if(Number(pending.orgId)!==orgId || Date.now()-Number(pending.time)>7*86400000){localStorage.removeItem(referralKey);return}
        if(Number(store.getters.userInfo?.id)===Number(pending.referrerId)){localStorage.removeItem(referralKey);return}
        let browserId=localStorage.getItem(browserKey)
        if(!browserId){browserId=newBrowserId();localStorage.setItem(browserKey,browserId)}
        const result=await customerRequest.recordListShareVisit(orgId,Number(pending.referrerId),browserId)
        if(result.data===true)localStorage.removeItem(referralKey)
      }catch{ /* 弱网时保留入口，下一次路由变化可重试。 */ }
    },{immediate:true})
    watch(route, (from, to) => {
      const { fullPath, meta, name, params, path, query } = to
      store.commit('app/addTagView', {
        fullPath,
        meta,
        name,
        params,
        path,
        query,
        title: getTitle(meta)
      })
    })
    const scrolltop=ref(0)
    onMounted(() => {
      const ele=document.querySelector('.app-main')
      if(ele){
        ele?.addEventListener('scroll', ()=>{
          scrolltop.value=ele.scrollTop
        })
      }
      
    })
    return {
      route,path,scrolltop
    }
  }
})

